import _ from 'lodash';
import React from 'react';
import { FormattedDateParts } from 'react-intl';
import { PaymentMethods } from '../../types/receipt.type';
import { ReceiptPayment } from 'guest-data-types-ts-lib';
import './PaymentsReceipt.scss';
import { CurrencyUtils, TranslationUtils } from '../../utils';

interface ReceiptPaymentProps {
    payments: Array<ReceiptPayment>;
    currency: string;
    locale: string;
}

const getPaymentInfo = (payment: ReceiptPayment): string => {
    let paymentInfo = payment.method ? payment.method : '';
    if (payment.method === PaymentMethods.TRANSFER && payment.type === PaymentMethods.RESERVATION_CREDIT) {
        paymentInfo = TranslationUtils.get('fsc_credits');
    } else if (payment.method === PaymentMethods.NOTE) {
        paymentInfo = PaymentMethods.CHECK;
    } else if (payment.method === PaymentMethods.CREDIT_CARD) {
        paymentInfo = payment.type ? payment.type : '';
    }
    return paymentInfo;
};

const formatPayment = (payment: ReceiptPayment, locale: string) => {
    const {
        amount: { total, currency },
        transaction_type,
    } = payment;
    const isRefund = transaction_type == 'CREDIT';
    const sign = isRefund ? '+' : '-'; // show refunds amounts with +
    return `${sign} ${CurrencyUtils.formatCurrency(total, currency, locale)}`;
};

export const PaymentsReceipt: React.FC<ReceiptPaymentProps> = (props) => {
    const { payments, locale } = props;
    return (
        <React.Fragment>
            {_.map(payments, (item, i) => (
                <div className="payments-receipt" key={i}>
                    <div id={`payment-item-${i}`}>
                        <span className={'body-regular'} tabIndex={0}>
                            <FormattedDateParts value={new Date(item.created)} year="numeric" month="2-digit" day="2-digit">
                                {(parts: Intl.DateTimeFormatPart[]) => <>{`${parts[0].value}/${parts[2].value}/${parts[4].value}`}</>}
                            </FormattedDateParts>
                        </span>
                        <span tabIndex={0} className="body-regular card-type-cell">
                            {getPaymentInfo(item)}
                        </span>
                        <span tabIndex={0} className="body-regular card-type">
                            {item.last_four ? _.padStart(`${item.last_four}`, 8, '*') : ''}
                        </span>
                    </div>
                    <div id={`payment-detail-2-${i}`} className=" body-regular payments-receipt-amount">
                        <span tabIndex={0}>{formatPayment(item, locale)}</span>
                    </div>
                </div>
            ))}
            <hr />
        </React.Fragment>
    );
};
